import React from "react";
import QNGLogo from "assets/images/qng_logo_large.svg";
import BNBLogo from "assets/images/bnb_logo_large.svg";
import DGNBLogo from "assets/images/dgnb_logo_large.svg";
import LevelsLogo from "assets/images/levels_logo_large.svg";
import { certificationExportStore as certExportStore } from "../CertificationExportStore";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { useCertificationLicense } from "hooks/useCertificationLicense";
import CertificationSystemCard from "./CertificationSystemCard";

type CertSystem = {
  /** Settings/license key (bnb | dgnb18 | dgnb23 | levels | qng). */
  id: string;
  /** Name passed to the export store; matches the CertificationName enum. */
  certName: string;
  icon: string;
  className: string;
  title?: string;
  titleKey?: string;
};

const CERT_SYSTEMS: CertSystem[] = [
  {
    id: "bnb",
    certName: "BNB",
    title: "BNB",
    icon: BNBLogo,
    className: "col-span-2",
  },
  {
    id: "dgnb18",
    certName: "DGNB 2018",
    title: "DGNB 2018",
    icon: DGNBLogo,
    className: "col-span-2",
  },
  {
    id: "dgnb23",
    certName: "DGNB 2023",
    title: "DGNB 2023",
    icon: DGNBLogo,
    className: "col-span-2",
  },
  {
    id: "levels",
    certName: "Level(s)",
    title: "LEVEL (s)",
    icon: LevelsLogo,
    className: "col-span-3",
  },
  {
    id: "qng",
    certName: "QNG",
    titleKey: "certExport.qngTitle",
    icon: QNGLogo,
    className: "col-span-3",
  },
];

const ChooseCertSystem = () => {
  const { t } = useTranslation();
  const { isAvailable, isEnabled, entitlementLoaded } =
    useCertificationLicense();

  const selectSystem = (certName: string) => {
    certExportStore.setCertAndConformityId(certName);
    certExportStore.setActiveStep(1);
  };

  // Tier 1: only show certs the license entitles.
  const availableSystems = CERT_SYSTEMS.filter((system) =>
    isAvailable(system.id)
  );

  return (
    <>
      <div className="text-base leading-6 !font-medium text-gray-800 mb-4">
        {t("certExport.step1Title")}
      </div>
      {entitlementLoaded && availableSystems.length === 0 ? (
        <div className="text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-md p-4">
          {t("certExport.noCertificationsInLicense")}
        </div>
      ) : (
        <div className="gap-6 grid grid-cols-6">
          {availableSystems.map((system) => (
            <div key={system.id} className={system.className}>
              <CertificationSystemCard
                title={
                  system.titleKey ? t(system.titleKey) : system.title ?? ""
                }
                icon={system.icon}
                alt={system.id}
                enabled={isEnabled(system.id)}
                onSelect={() => selectSystem(system.certName)}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default observer(ChooseCertSystem);
